export const USER_ME_REQUEST = "USER_ME_REQUEST";
export const USER_ME_SUCCESS = "USER_ME_SUCCESS";
export const USER_ME_FAILURE = "USER_ME_FAILURE";

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE";

export const USER_LOGOUT_REQUEST = "USER_LOGOUT_REQUEST";
export const USER_LOGOUT_SUCCESS = "USER_LOGOUT_SUCCESS";
export const USER_LOGOUT_FAILURE = "USER_LOGOUT_FAILURE";

export const DELETE_INVEST_REQUEST = "DELETE_INVEST_REQUEST";
export const DELETE_INVEST_SUCCESS = "DELETE_INVEST_SUCCESS";
export const DELETE_INVEST_FAILURE = "DELETE_INVEST_FAILURE";

export const GET_NOTIFICATION_REQUEST = "GET_NOTIFICATION_REQUEST";
export const GET_NOTIFICATION_SUCCESS = "GET_NOTIFICATION_SUCCESS";
export const GET_NOTIFICATION_FAILURE = "GET_NOTIFICATION_FAILURE";

export const GET_DASHBORD_REQUEST = "GET_DASHBORD_REQUEST";
export const CLEAR_UNREAD_NOTIFICATIONS = "CLEAR_UNREAD_NOTIFICATIONS";
export const SET_EMAIL_REQUEST = "SET_EMAIL_REQUEST";
export const SET_LOCALE_REQUEST = "SET_LOCALE_REQUEST";
export const CLEAR_ERROR_MESSAGE = "CLEAR_ERROR_MESSAGE";

export const SEND_INVEST = "SEND_INVEST";

export const PERFORM_WITHDRAW = "PERFORM_WITHDRAW";

export const GET_TICKERS_REQUEST = "GET_TICKERS_REQUEST";
export const GET_TICKERS_SUCCESS = "GET_TICKERS_SUCCESS";
export const GET_TICKERS_FAILURE = "GET_TICKERS_FAILURE";

export const GET_TRANSACTIONS_REQUEST = "GET_TRANSACTIONS_REQUEST";
export const GET_TRANSACTIONS_SUCCESS = "GET_TRANSACTIONS_SUCCESS";
export const GET_TRANSACTIONS_FAILURE = "GET_TRANSACTIONS_FAILURE";

export const CANCEL_WITHDRAW_REQUEST = "CANCEL_WITHDRAW_REQUEST";
export const CANCEL_WITHDRAW_SUCCESS = "CANCEL_WITHDRAW_SUCCESS";
export const CANCEL_WITHDRAW_FAILURE = "CANCEL_WITHDRAW_FAILURE";



// WEBPACK FOOTER //
// ./src/ducks/user/constants.js